export default __webpack_public_path__ + "static/media/skill4.c91b2633.svg";